<template>
  <div class="schoolBox relative">
    <div class="title">
      <div class="title_left">主体信息维护</div>
    </div>
    <div v-if="false" class="innerBox">
      <ErrorTemplate></ErrorTemplate>
    </div>
    <div v-if="true" style="margin-bottom: 100px">
      <ToggleForm title="概况" :zoomed="false">
        <div class="box mt20 clear_a">
          <div class="schoolImg">
            <img
              :src="obj.profileImgUrl ? obj.profileImgUrl : profileImgUrl"
              class="movePoin"
              @click.stop="ifbig(obj.profileImgUrl ? obj.profileImgUrl : '-1')"
            />
          </div>
          <ul class="description">
            <li class="textell">名称：{{ obj.buyerName }}</li>
            <li>法人(负责人)：{{ obj.legalPerson }}</li>
            <li class="textell">地址：{{ obj.address }}</li>
            <li>量化等级：{{ obj.qualityLevel }}</li>
            <li>风险分级：{{ !obj.riskLevel?'':obj.riskLevel }}</li>
          </ul>
        </div>
      </ToggleForm>
      <ToggleForm title="简介" :zoomed="true">
        <div class="box mt20">
          {{ obj.profile ? obj.profile : "暂无简介" }}
        </div>
      </ToggleForm>
      <ToggleForm title="经营信息" :zoomed="true">
        <div class="box mt20">
          <ul class="description">
            <li>经营面积：{{ !obj.cover?'-':obj.cover }}{{obj.cover?'㎡':''}}</li>
            <li>经营场所：{{ !obj.workspace?'-':obj.workspace }}</li>
            <li>GPS地址：{{ !obj.gpsAddress?'-':obj.gpsAddress }}</li>
            <div class="newInfo-row">
              <li>经度：{{ !obj.lng?'-':obj.lng }}</li>
              <li>纬度：{{ !obj.lat?'-':obj.lat }}</li>
            </div>
            <div class="newInfo-row">
              <li>行业类型：{{ obj.buyerType }}</li>
              <li>学校类型：{{ !obj.scType?'-':obj.scType }}</li>
            </div>
            <div class="newInfo-row">
              <li>营业状态：{{ !obj.workStatus?'-':workStatus[obj.workStatus-1] }}</li>
              <li>从业人数：{{ !obj.empNumber?'-':obj.empNumber }}</li>
            </div>
            <div class="newInfo-row">
              <li>主体业态：{{ !obj.entityType?'-':entityType[obj.entityType-1] }}</li>
              <li>是否提供网络外卖服务：{{ !obj.takeOut?'-':takeOut[obj.takeOut-1] }}</li>
            </div>

            <li>网络经营：{{ !obj.onlineType?'-':onlineType[obj.onlineType-1] }}</li>
          </ul>
        </div>
      </ToggleForm>
      <ToggleForm title="证照信息" :zoomed="true">
        <div class="box mt20 clear_a">
          <div class="license mr20">
            <img
              :src="obj.creditImgUrl ? obj.creditImgUrl : creditImgUrl"
              class="movePoin"
              @click.stop="ifbig(obj.creditImgUrl ? obj.creditImgUrl : '-1')"
            />
            <p>营业执照</p>
            <p class="number">
              营业执照编号：{{ obj.creditCode ? obj.creditCode : "-" }}
            </p>
          </div>
          <div class="license">
            <img
              :src="obj.licenceImgUrl ? obj.licenceImgUrl : licenceImgUrl"
              class="movePoin"
              @click.stop="ifbig(obj.licenceImgUrl ? obj.licenceImgUrl : '-1')"
            />
            <p>
              许可证
              <el-tag size="mini" v-if="obj.licenceStatus == 2" type="danger"
                >即将过期</el-tag
              >
              <el-tag size="mini" v-if="obj.licenceStatus == 3" type="danger"
                >已过期</el-tag
              >
            </p>
            <p class="number">
              许可证编号：{{ obj.licence ? obj.licence : "-" }}
            </p>
            <p class="number">
              有效期截至：{{ obj.licenceExpdate ? obj.licenceExpdate : "-" }}
            </p>
          </div>
        </div>
      </ToggleForm>
      <ToggleForm title="荣誉" :zoomed="true">
        <div class="box mt20">
          <p>{{ obj.honour ? obj.honour : "暂无荣誉介绍" }}</p>
          <ul v-if="obj.honourImages.length > 0" class="imgUl mt20 clear_a">
            <!-- @click.stop="ifbig(baseUrl+'/'+item.fileUrl)"  -->
            <li
              v-for="(item, i) in obj.honourImages"
              :key="item.fileId"
              @click="previewImg(obj.honourImages, i, '荣誉图片')"
            >
              <img :src="baseUrl + '/' + item.fileUrl" />
            </li>
          </ul>
          <p v-else class="mt20">暂无荣誉图片</p>
        </div>
      </ToggleForm>
      <ToggleForm title="主体图片" :zoomed="true">
        <div class="box mt20">
          <ul v-if="obj.entityImages.length > 0" class="imgUl clear_a">
            <li
              v-for="(item, i) in obj.entityImages"
              :key="item.fileId"
              @click="previewImg(obj.entityImages, i, '主体图片')"
            >
              <img :src="baseUrl + '/' + item.fileUrl" />
            </li>
          </ul>
          <p v-else>暂无主体图片</p>
        </div>
      </ToggleForm>
      <div
        class="big-img relative"
        v-show="showBigPic"
        @click.stop="ifbig('-1')"
      >
        <img :src="bigImgSrc" />
      </div>
      <div class="foot-btn">
        <div>
          <el-button type="primary w70 " @click="edit">编辑</el-button>
        </div>
      </div>
    </div>
    <Preview
      :showImg="PreviewShow"
      @close="PreviewShow = false"
      :currentIndex="PreviewIndex"
      :title="PreviewTitle"
      :imgList="PreviewFileList"
    ></Preview>
  </div>
</template>

<script>
import Preview from "components/previewImg";
import ToggleForm from "components/ToggleForm";
import * as api from "api/personApi";
export default {
  name: "school",
  components: {
    ToggleForm,
    Preview,
  },
  data() {
    return {
      PreviewShow: false,
      PreviewFileList: [],
      PreviewIndex: 0,
      PreviewTitle: "",
      baseUrl: this.$store.state.common.baseUrl,
      profileImgUrl: require("../../assets/img/notProfileImgUrl.png"),
      licenceImgUrl: require("../../assets/img/notLicenceImgUrl.png"),
      creditImgUrl: require("../../assets/img/notCreditImgUrl.png"),
      bigImgSrc: null, //拍照图片查看路径
      showBigPic: false, //拍照图片查看是否显示
      obj: {
        entityImages: [],
        honourImages: [],
      },
      workStatus: [
        '正常营业','暂停营业','停止营业'
      ],
      onlineType:['美团','饿了么'],
      takeOut:['是','否'],
    buyerType: [
       {value:'KINDSC',label:'幼儿园'},
       {value:'PRISC',label:'小学'},
       {value:'MIDSC',label:'初中'},
       {value:'HIGSC',label:'高中'},
       {value:'UNVSC',label:'大学'},
       {value:'HSPT',label:'医院'},
       {value:'CORP',label:'企事业单位'},
       {value:'GOV',label:'政府机关'},
       {value:'RSTNT',label:'社会餐饮'},
       {value:'SPMKT',label:'商超'},
       {value:'HOTEL',label:'酒店'},
       {value:'WSMKT',label:'批发'},
       {value:'FMMKT',label:'农贸'},
       {value:'PERSON',label:'个体'},
       {value:'CIRCULATION',label:'流通主体'},
       {value:'NURSING_HOME',label:'养老院'},
       {value:'XJBT',label:'新疆生产建设兵团'},
    ],
    scType: [
        {value:'PUBLIC',label:'公立'},
        {value:'PRIVATE',label:'私立'},
    ],
     entityType:[
        '小吃店',
        '快餐店',
        '小型餐饮',
        '中型餐饮',
        '大型餐饮',
        '特大型餐饮',
        '饮品店（含甜品站）',
        '集体用餐配送单位',
        '中央厨房',
        '学校（含托幼机构）食堂',
        '机关企事业单位食堂',
        '工地食堂',
        '其他食堂',
      ],
    };
  },
  mounted() {
    api.xcwsEntityExt().then((r) => {
      if (r.code == 200) {
        this.obj = r.data;
        if (this.obj.profileImgUrl) {
          this.profileImgUrl = this.obj.profileImgUrl;
        }
        if (this.obj.licenceImgUrl) {
          this.licenceImgUrl = this.obj.licenceImgUrl;
        }
        if (this.obj.creditImgUrl) {
          this.creditImgUrl = this.obj.creditImgUrl;
        }
        for (let i of this.buyerType) {
          if (this.obj.buyerType == i.value) {
            this.obj.buyerType = i.label
          }
        }
        for (let i of this.scType) {
          if (this.obj.scType == i.value) {
            this.obj.scType = i.label
          }
        }
      }
    });
  },
  methods: {
    previewImg(imgList, index, title) {
      this.PreviewFileList = [];
      imgList.map((item) => {
        this.PreviewFileList.push(this.baseUrl + "/" + item.fileUrl);
      });
      this.PreviewIndex = index;
      this.PreviewTitle = title;
      this.PreviewShow = true;
    },
    edit() {
      this.$router.push({
        name: "schoolEdit",
      });
    },
    ifbig(item) {
      if (this.bigImgSrc == null || this.bigImgSrc != item) {
        this.bigImgSrc = item;
        this.showBigPic = true;
      } else {
        this.bigImgSrc = null;
      }
      if (item == -1) {
        this.showBigPic = false;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.schoolBox {
  width: calc(100% - 40px);
  height: 100%;
  padding: 0 100px 0px 20px;

  .title {
    height: 60px;
    line-height: 60px;

    .title_left {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 50%;
      height: 100%;

      .type {
        color: #70ce97;
      }
    }
  }
}

.box {
  width: calc(100% - 60px);
  padding: 0 30px;
  min-height: 100px;

  .schoolImg,
  .schoolImg > img {
    width: 140px;
    height: 140px;
  }

  .description {
    width: calc(100% - 170px);
    margin-left: 30px;
    .newInfo-row {
      display: flex;
      justify-content: space-around;
    }
    li {
      width: 100%;
      margin-top: 15px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiR;
      color: rgba(102, 102, 102, 1);
    }
  }

  .license {
    width: 240px;

    img {
      width: 240px;
      height: 180px;
      margin-bottom: 20px;
    }

    p {
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }

    .number {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-top: 8px;
    }
  }
}

.innerBox {
  width: calc(100% - 60px);
  padding: 20px 30px;
  height: calc(100% - 125px);
  background: #fff;
  border-radius: 10px;
}

.imgUl {
  width: 100%;
  min-height: 200px;

  li {
    width: 200px;
    height: 200px;
    margin-right: calc((100% - 1200px) / 5);
    margin-bottom: 20px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  li:nth-child(6n) {
    margin-right: 0;
  }
}

.big-img {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;

  > img {
    display: block;
    max-height: 700px;
  }
}
</style>